import { render, staticRenderFns } from "./BoxContent1.vue?vue&type=template&id=32751393&scoped=true"
import script from "./BoxContent1.vue?vue&type=script&lang=js"
export * from "./BoxContent1.vue?vue&type=script&lang=js"
import style0 from "./BoxContent1.vue?vue&type=style&index=0&id=32751393&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32751393",
  null
  
)

export default component.exports